<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'CreateUserProfileList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Create User Profile
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Create User Profile</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CreateUserProfile">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>

                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Pool Name</label>
                    <multiselect
                      v-model="value.pool_name"
                      :options="poolName"
                      placeholder="Select Pool Name"
                      :searchable="true"
                      :multiple="false"
                      id="pool_name"
                      @input="getVpnPoolIP"
                      v-bind:class="{ 'has-error': errors.has('pool_name') }"
                      v-validate="'required'"
                      name="pool_name"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('pool_name')">
                      {{ errors.first("pool_name") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">IP Address</label>
                    <input
                      type="text"
                      id="ip_address"
                      name="ip_address"
                      v-bind:class="{ 'has-error': errors.has('ip_address') }"
                      v-validate.lazy="'required|ip'"
                      v-model="value.ip_address"
                      class="form-control ip_address"
                      placeholder="IP Address"
                    />
                    <div class="help text-danger" v-show="errors.has('ip_address')">
                      {{ errors.first("ip_address") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Username</label>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      v-bind:class="{ 'has-error': errors.has('username') }"
                      v-validate="{ required: true, regex: /^\w+$/ }"
                      v-model="value.username"
                      class="form-control username"
                      autocomplete="off"
                      placeholder="Username"
                    />
                    <div class="help text-danger" v-show="errors.has('username')">
                      {{ errors.first("username") }}
                    </div>
                  </div>

                  <div class="form-group mb-3 required">
                    <label class="control-label">password</label>
                    <div class="password">
                      <input
                        name="password"
                        v-model.trim="value.password"
                        class="form-control"
                        placeholder="Password"
                        v-validate="'required'"
                        :class="{ 'has-error': errors.has('password') }"
                        @focus="setShowPassword"
                        :type="showPassword ? 'text' : 'password'"
                      />
                      <span class="password-toggle" @click="showPassword = !showPassword">
                        <i
                          :class="{
                            'icon-eye-off': showPassword,
                            'icon-eye': !showPassword,
                          }"
                        ></i>
                      </span>
                    </div>

                    <div class="help text-danger" v-show="errors.has('password')">
                      {{ errors.first("password") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI, PermissionChecker } from "@/services/api";

export default {
  name: "CreateUserProfileForm",
  metaInfo: {
    title: "Create User Profile | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      audraName: {},
    },
    poolName: [],
    showPassword: true,
    emptyPassword: true,
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/create_user_profiles";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/create_user_profiles/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "CreateUserProfileList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/create_user_profiles/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }

      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.showPassword = false;
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getVpnPoolName()
        .then((response) => {
          this.poolName = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
      // this.value.accountId = LocalStorage.get('accountId')
      console.log(this.value);
      this.is_loading = false;
    },

    async getVpnPoolName() {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-pool-name", {
            params: { userAccountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getVpnPoolIP(event) {
      if (!event) {
        this.value.serverip = "";
        this.value.ip_address = "";
        return;
      }
      const _this = this;
      axios
        .get("/get-ip-pool", {
          params: {
            accountId: LocalStorage.get("accountId"),
            pool_name: event,
          },
        })
        .then((response) => {
          let data = response.data.split("/");
          _this.value.serverip = data[0] ? data[0] : "";
          data = data[0].split(".");
          _this.value.ip_address = data[0] + "." + data[1] + "." + data[2] + ".";
          this.$forceUpdate();
          // console.log(_this.value.ip_address)
        })
        .catch((error) => {
          // reject(error);
          console.log(error);
        });
    },
    setShowPassword() {
      if (!this.value.password && this.emptyPassword) {
        this.emptyPassword = false;
        this.showPassword = false;
      }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
